import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoryComponent } from './components/category/category.component';
import { HomeComponent } from './components/home/home.component';
import { StaticComponent } from './components/static/static.component';
import { SearchComponent } from './components/search/search.component';
import { CategoryListComponent } from './components/category-list/category-list.component';
import { ScriptNames, scriptRegistry } from '../shared/enum/schema';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      seoScript: ScriptNames.website
    }
  },
  {
    path: 'category',
    children: [
      {
        path: '',
        component: CategoryListComponent
      },
      {
        path: 'all',
        component: CategoryComponent
      },
      {
        path: ':id/:name',
        component: CategoryComponent
      }
    ]
  },

  {
    path: 'pages/:page',
    component: StaticComponent
  },
  {
    path: 'home/:id',
    component: HomeComponent
  },
  {
    path: 'search',
    children: [
      {
        path: '',
        component: SearchComponent
      },
      {
        path: ':keyword',
        component: SearchComponent
      },
      {
        path: ':keyword/all',
        component: SearchComponent,
        data: {detailMode: true}
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CategoryRoutingModule { }
